import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {IsoCountry} from '../objects/iso-country';
import {IsoCurrency} from '../objects/iso-currency';
import {ConfigUtil} from '@shared/services/config.util';

@Injectable({
  providedIn: 'root'
})
export class IsoApi {
  private readonly httpClient = inject(HttpClient);

  private readonly endpoint: string;

  constructor() {
    this.endpoint = `${ConfigUtil.get('api')['backend']}/iso`;
  }

  public countries(): Observable<IsoCountry[]> {
    return this.httpClient.get<IsoCountry[]>(`${this.endpoint}/countries`);
  }


  public currencies(): Observable<IsoCurrency[]> {
    return this.httpClient.get<IsoCurrency[]>(`${this.endpoint}/currencies`);
  }

}
